<script>
	// Stores 
	import { 
		mailProposta,
		textSite, 
		textEndereco, 
		textAtendimento,
		linkIframeMapa,
		comoChegar,
	} from '../store.js';    

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";
	import BarraAtendimento from '../components/BarraAtendimento.svelte';

	// Code
	let titlePage = 'Proposta de Administração de Condomínio';

	let enderecoSimples = $textEndereco.replaceAll('<br class=\'hidden-sm hidden-xs\'>', '');

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email'
		},
		{
			title:      'Você é?',
			name:       'eh-sindico',
			type:       'select',
			selectValues: [
				{
					title: 'Selecione',
					value: ''
				},
				{
					title: 'Síndico',
					value: 'Síndico'
				},
				{
					title: 'Condômino',
					value: 'Condômino'
				}
			]
		},          
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required'
		},
		   
	];      
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é?: {eh-sindico}
Nome do condomínio: {condominio-nome}

{info}
	`;

	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage}>
	<div class="subtitle" slot="subtitle">
		<div class="container">
			<p>Estamos prontos para lhe assessorar e indicar as melhores escolhas para o seu condomínio. Venha nos conhecer ou solicite uma proposta utilizando o formulário.</p>
		</div>
	</div>
</PageHeader>

<div class="container">
	<div class="grid grid-size--2 grid-size-sm--1">
		<BarraAtendimento />
		<section class="atendimento">
			<div class="text-center">
				<h3><i class="far fa-envelope"></i> Solicite uma proposta</h3>
			</div>	
			<div class="flex flex-center mt-20 mb-20">
				<div class="flex-1 background-gray round-all pa-30">
					<Forms fields={fields} destiny={$mailProposta} subjectTitle="{titlePage}" {message} htmlbody={false} />
				</div>
			</div>
		</section>
	</div>
</div>

<div class="mapa">
	<div class="container">
		<div class="flex flex-spaced sm-flex-column mt-60 mb-40 gap-10">
			<h3><i class="far fa-map-marker-alt"></i> Endereço: {@html enderecoSimples}</h3>
			<div class="flex flex-end sm-flex-center flex-1 gap-10">
				{#each $comoChegar as l}
				<div class="item">
					<a href="{l.link}" target="_blank" title="{$textSite} via {l.title}">
						{@html l.icon} {l.title} 
					</a>
				</div>
				{/each}
			</div>
		</div>
	</div>
	<iframe style="width:100%;" height="500" id="gmap_canvas" src="{$linkIframeMapa}" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
</div>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
</style>